<!-- <p-dialog
  header="Prescription"
  *ngIf="displayModel"
  [(visible)]="displayModel"
  [modal]="true"
  [contentStyle]="{ overflow: 'scroll' }"
  styleClass="p-dialog-width"
  [baseZIndex]="10000"
  [draggable]="false"
  id="prescription"
  [resizable]="false"
  (onHide)="CloseDialog()"
  [style]="{ width: '80%' }"
>
  <div class="col-md-12">
    <ng-container
      *ngIf="
        this.prescriptionApiResult.PromiseResult.success &&
        this.prescriptionData.consultation.p_prescriptions.length > 0
      "
    >
      <p-button
        icon="pi pi-check"
        (click)="print()"
        label="Print"
        styleClass="p-button-text"
      ></p-button>

      <app-prescription-details
        [patient_id]="this.member"
        [data]="prescriptionData"
        [dataId]="showPrescriptiond"
      ></app-prescription-details>
    </ng-container>
    <ng-container
      *ngIf="
        !this.prescriptionApiResult.PromiseResult.success ||
        (this.prescriptionApiResult.PromiseResult.success &&
          this.prescriptionData.consultation.p_prescriptions.length == 0)
      "
    >
      <p>Prescription not available</p>
    </ng-container>
    <h4 *ngIf="this.posting">Fetching data...</h4>
    <p-progressSpinner
      [style]="{ width: '50px', height: '50px' }"
      *ngIf="this.posting"
      strokeWidth="6"
    >
    </p-progressSpinner>
  </div>
</p-dialog> -->
<!-- <app-prescription-details
  *ngIf="
    this.prescriptionApiResult.PromiseResult.success &&
    this.prescriptionData.consultation.p_prescriptions.length > 0 &&
    displayModel
  "
  [patient_id]="this.member"
  [data]="this.prescriptionData"
  [dataId]="printContent"
>
</app-prescription-details> -->
<!-- <ng-container *ngIf="displayModel1">
  <p-dialog
    header="Report"
    [(visible)]="displayModel1"
    [modal]="true"
    [contentStyle]="{ overflow: 'scroll' }"
    [style]="{ width: '100vw' }"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
    (onHide)="CloseDialog()"
  >
    <div *ngIf="this.doctorReportsApiResult.PromiseResult.success">
      <div class="spaces"></div>

      <app-doctorreportpdf
        [data]="this.doctorReportsData"
        [dataId]="showDoctorReports"
      ></app-doctorreportpdf>

      <p-button
        icon="pi pi-check"
        (click)="print()"
        label="Print"
        styleClass="p-button-text"
      ></p-button>
    </div>
  </p-dialog>

  <div *ngIf="this.doctorReportsApiResult.PromiseResult.success">
    <div class="spaces"></div>

    <app-doctorreportpdf
      [data]="this.doctorReportsData"
      [dataId]="printContent"
    ></app-doctorreportpdf>
  </div>
</ng-container> -->
<div class="card no-margin">
  <label for="patient" style="margin: 2px; margin-right: 80px; vertical-align: super">
    <b>Choose a Patient :</b>
  </label>
  <p-dropdown id="patient" class="notranslate" [(ngModel)]="selectMemeber" placeholder="Select" optionLabel="label"
    [options]="members_list" (ngModelChange)="onChange()"></p-dropdown>
</div>

<div class="card no-margin" *ngIf="selectMemeber">
  <div class="mat-elevation-z8">
    <div>
      <div class="table-responsive text-center justify-content-center" style="
          font-size: 14px;
          margin-bottom: 20px;
          text-align: center;
          vertical-align: center;
        ">
        <p-table #dt [value]="doctor_reports" styleClass="p-datatable-customers" [rows]="10" [paginator]="true"
          [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[10, 25, 50]" dataKey="id" styleClass="p-datatable-customers" [scrollable]="true"
          [globalFilterFields]="[
            'consultation_request_number',
            'consultation_date',
            'consultation_name',
            'speciality',
            'doctor_name',
            'referred_to_nutritionist_value'
          ]">
          <ng-template pTemplate="caption">
            <div class="table-header float-right">
              <span class="p-input-icon-left">
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                  placeholder="Search" />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="consultation_request_number" style="font-weight: bold">
                R No
                <p-sortIcon field="consultation_request_number"></p-sortIcon>
              </th>
              <th pSortableColumn="consultation_date" style="font-weight: bold">
                Date <p-sortIcon field="consultation_date"></p-sortIcon>
              </th>
              <th pSortableColumn="consultation_name" style="font-weight: bold">
                Consultation <p-sortIcon field="consultation_name"></p-sortIcon>
              </th>
              <th pSortableColumn="speciality" style="font-weight: bold">
                Speciality <p-sortIcon field="speciality"></p-sortIcon>
              </th>
              <th pSortableColumn="doctor_name" style="font-weight: bold">
                Doctor Name <p-sortIcon field="doctor_name"></p-sortIcon>
              </th>
              <th pSortableColumn="reports" style="font-weight: bold">
                Reports
              </th>
              <th pSortableColumn="prescriptions" style="font-weight: bold">
                Prescriptions
              </th>
              <th pSortableColumn="referred_to_nutritionist_value" style="font-weight: bold" *ngIf="!this.is_uk_country">
                Referred to Nutrition Coach?
                <p-sortIcon field="referred_to_nutritionist_value"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-cons>
            <tr [pSelectableRow]="cons">
              <td class="notranslate">
                {{ cons.consultation_request_number }}
              </td>
              <td>
                {{ cons.consultation_date | date: 'medium' }}
              </td>
              <td>
                {{ cons.consultation_name }}
              </td>
              <td class="notranslate">
                {{ cons.speciality }}
              </td>
              <td class="notranslate">
                {{ cons.doctor_name }}
              </td>
              <td>
                <span *ngIf="cons.reports_key != null">
                  <p-button (click)="getReportBase64(cons.reports_url)" icon="pi pi-download"
                    label="Download"></p-button>
                </span>
                <span *ngIf="cons.reports_key == null"> N/A </span>
              </td>
              <td>
                <span *ngIf="cons.prescription_key != null">
                  <p-button (click)="getReportBase64(cons.prescription_url)" icon="pi pi-download"
                    label="Download"></p-button>
                </span>
                <span *ngIf="cons.prescription_key == null"> N/A </span>
              </td>
              <td *ngIf="!this.is_uk_country">
                {{ cons.referred_to_nutritionist_value }}
                <span *ngIf="cons.referred_to_nutritionist_boolean">
                  <p-button icon="pi pi-external-link"
                    [routerLink]="['/', this.slug, 'patient', 'nutrition-and-health']"></p-button>
                </span>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">No Data found.</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="paginatorleft"> </ng-template>

          <ng-template pTemplate="paginatorright"> </ng-template>
        </p-table>
      </div>
    </div>
    <div style="text-align-last: right">
      <p-button type="button" [style]="{
          'margin-right': '5px',
          'margin-top': '3px',
          'background-color': 'white',
          color: '#004AAD',
          'border-radius': '5px'
        }" [routerLink]="['/', this.slug, 'patient', 'nutrition-and-health']" label="Back" class="p-button-lg"
        icon="pi pi-arrow-left"></p-button>
    </div>
  </div>

  <div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success != null && response.success == false">
    <p *ngIf="response.error != null">{{ response.error.message }}</p>
    <div *ngIf="serverError.error != null && serverError.statusCode != 500">
      <p *ngFor="let message of serverError.message">{{ message }}</p>
    </div>
    <div *ngIf="serverError.error != null && serverError.statusCode == 500">
      <p>{{ serverError.message }}</p>
    </div>
  </div>
  <h4 *ngIf="posting">Fetching your data...</h4>
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" *ngIf="posting" strokeWidth="6"></p-progressSpinner>
</div>